<template>
  <div class="mailInputBox" :class="{mailInputWrap: isActiveStatus, activatorWrap: !isActiveStatus}">
    <div v-if="isActiveStatus">
      <div class="mailInputToolbar">
        <div class="mailSubtitle">{{reduceSubject(replyInfo.subject, subjectMaxLength.minScreen)}}</div>
        <div style="width:65px;">
          <v-btn small icon @click="toMinimize" v-if="isDefaultSize" class="mailToolbarIcon"><i class="UXicon-component_min"></i></v-btn>
          <v-btn small icon @click="toMinimize" v-else class="mailToolbarIcon"><i class="UXicon-component_middle"></i></v-btn>
          <v-btn small icon @click.stop="toggleEditorDialog" class="mailToolbarIcon"><i class="UXicon-component_max"></i></v-btn>
        </div>
      </div>
      <div class="mailEditorBox" v-show="isDefaultSize">
        <dl>
          <dd>
            <div class="receiver">
              To : <span>{{replyInfo.recipientTo}}</span>
            </div>
          </dd>
          <dd v-if="isDefaultSize">
            <mail-editor ref="mailEditor" :content="replyInfo.text" :minHeight="180" :height="218"
                         :updateContent="updateContent" :editorConfig="editorConfig"/>
          </dd>
          <dd v-if="isAttachedFile">
            <div class="attachArea">
              <span>{{convertFileSize(getAllFileSize())}} / {{maxFileLength}}MB</span>
              <p v-for="(file, index) in replyInfo.files" :key="index">
                {{reduceFileName(file.name, fileNameMaxLength.minScreen)}} [{{convertFileSize(file.size)}}]
                <i class="UXicon-close" @click="removeFile(file)"></i>
              </p>
            </div>
          </dd>
          <dd style="display: flex">
            <div class="mailBtnLeft">
              <v-btn dark color="#FFE3E0" class="mailSendBtn UXbtn"
                     :disabled="!isPermission || loading || fileLoading"
                     @click.native="sendMessage">
                送信
              </v-btn>
            </div>
            <div class="mailBtnRight">
              <label :disabled="fileLoading">
                <v-progress-circular
                  v-show="fileLoading"
                  indeterminate
                  color="#919191"
                  size="17"
                  width="3"
                ></v-progress-circular>
                <a>
                  <input type="file"
                         accept="*/*"
                         @change="fileChanged"
                         @click="resetFileInput"
                         ref="fileInput"
                         :disabled="fileLoading"
                         multiple/>
                  <tooltip
                    :text="`ファイル添付 < 10MB`"
                    :is-icon="true"
                    alignment="top"
                    classes="UXicon-attach_outlined mailLinkIcon"
                    containter-class="attachIconCon"
                    v-show="!fileLoading"/>
                </a>
              </label>
              <transfer-dialog :brandId="brandId" :agentId="agentId" :chatRoomId="chatRoomId" :isPermission="isPermission"
                               :status="status" :isDisabled="loading || fileLoading"></transfer-dialog>
              <quit-dialog :chatRoomId="chatRoomId" :isDisabled="loading || fileLoading" :isPermission="isPermission" :is-mail-input="true"></quit-dialog>
            </div>
          </dd>
        </dl>
      </div>

      <v-dialog v-model="editorDialog" width="1024">
        <div class="mailInputBox expand mailInputWrap">
          <div>
            <div class="mailInputToolbar expandToolBar">
              <div>{{reduceSubject(replyInfo.subject, subjectMaxLength.minScreen)}}</div>
              <div>
                <v-btn small icon @click.stop="toggleEditorDialog" class="mailToolbarIcon"><i class="UXicon-component_reduction"></i></v-btn>
              </div>
            </div>
            <div class="mailEditorBox">
              <dl>
                <dd>
                  <div class="receiver">
                    To : <span>{{replyInfo.recipientTo}}</span>
                  </div>
                </dd>
                <dd>
                  <mail-editor v-if="editorDialog" ref="mailEditor" :content="replyInfo.text"
                               :min-height="600" :height="600"
                               :updateContent="updateContent" :editorConfig="editorConfig"/>
                </dd>
                <dd v-show="isAttachedFile">
                  <div class="attachArea">
                    <span>{{convertFileSize(getAllFileSize())}} / {{maxFileLength}}MB</span>
                    <p v-for="(file, index) in replyInfo.files" :key="index">
                      {{reduceFileName(file.name, fileNameMaxLength.minScreen)}} [{{convertFileSize(file.size)}}]
                      <i class="UXicon-close" @click="removeFile(file)"></i>
                    </p>
                  </div>
                </dd>
                <dd style="display: flex">
                  <div class="mailBtnLeft">
                    <v-btn dark color="#FFE3E0" class="mailSendBtn UXbtn"
                           :disabled="!isPermission || loading || fileLoading"
                           @click.native="sendMessage">
                      送信
                    </v-btn>
                    <label :disabled="fileLoading">
                      <v-progress-circular
                        v-show="fileLoading"
                        indeterminate
                        color="#919191"
                        size="17"
                        width="3"
                      ></v-progress-circular>
                      <a>
                        <input type="file"
                               accept="*/*"
                               @change="fileChanged"
                               @click="resetFileInput"
                               ref="fileInput"
                               :disabled="fileLoading"
                               multiple/>
                        <tooltip
                          :text="`ファイル添付 < 10MB`"
                          :is-icon="true"
                          alignment="top"
                          classes="UXicon-attach_outlined mailLinkIcon"
                          containter-class="attachIconCon"
                          v-show="!fileLoading"/>
                      </a>
                    </label>
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </v-dialog>
    </div>
    <div v-else>
      <div v-if="isSummaryStatus" class="actionActivatorWrap">
        <summary-dialog :brandId="brandId" :agentId="agentId" :chatRoomId="chatRoomId" :isPermission="isPermission"
                        :orderList="orderList"></summary-dialog>
      </div>
      <div v-if="isWaitingChatRoomCanBeStarted" class="actionActivatorWrap">
        <pick-chat-room :chatRoomId="chatRoomId" :roomInfo="roomInfo" :isPermission="isPermission"></pick-chat-room>
      </div>
    </div>
    <div class="mailDimmed" v-show="loading"></div>
  </div>
</template>

<script>
import mailEditor from '../../../jodit_editor'
import summaryDialog from './summary_dialog'
import transferDialog from './transfer_dialog'
import quitDialog from './quit_dialog'
import helper from 'util/helpers'
import UploadButton from 'vuetify-upload-button'
import pickChatRoom from './pick_chat_room'
import inputHeight from '@/constants/inputHeight'
import eventBus from '@/event_bus'
import {mapGetters} from 'vuex'
import chatRoomUtils from 'util/chatroom'
import Tooltip from '../../../tooltip'

export default {
  name: 'mail_input',
  props: ['ticketDispId', 'brandId', 'orderList', 'agentId', 'chatRoomId', 'active', 'status', 'channelName', 'lastMailMessage', 'resizeMailHeight', 'displayingChatRoomStatus', 'setMessageScrollBottom', 'isPickAvailable', 'roomInfo', 'isPermission'],
  components: {
    mailEditor,
    summaryDialog,
    transferDialog,
    quitDialog,
    'upload-btn': UploadButton,
    pickChatRoom,
    Tooltip
  },
  computed: {
    ...mapGetters([
      'displayingChatRoomId'
    ]),
    isSummaryStatus () {
      return this.status === 'SUMMARY_WAITING'
    },
    isActiveStatus () {
      return this.status === 'ACTIVE' || this.status === 'TRANSFER'
    },
    isWaitingChatRoomCanBeStarted () {
      // 전체탭에 있는 상담 대기중 방의 '상담 시작하기' 버튼 노출 제어용
      // 상담 대기중인 방을 보려면 전체탭에서 선택해 보는 방법밖에 없으므로 선택한 탭의 종류(전체)와 그 방의 상태(대기중)로 체크

      // TODO 상담 불가능한 권한이 생기면 예외 처리 필요
      return chatRoomUtils.showPickButton(this.status, this.displayingChatRoomStatus, this.isPickAvailable)
    },
    // 참조, 숨은참조 기능
    // useRecipientCc () {
    //   return this.replyInfo.recipientCc || this.useRecipientCcFlag === true
    // },
    // useRecipientBcc () {
    //   return this.replyInfo.recipientBcc || this.useRecipientBccFlag === true
    // },
    isAttachedFile () {
      return this.replyInfo.files.some(file => file.use === true)
    },
    isDefaultSize () {
      return this.editorHeight === inputHeight.DEFAULT
    }
  },
  watch: {
    lastMailMessage () {
      this.updateLastMailMessage()
    },
    replyInfo: { // 상담사가 답장하려고 정보를 변경하면 업데이트 되었다고 flag 를 변경한다.
      deep: true,
      handler: function () {
        // 처음 세팅된 원본 메일내용 !== 작성중인 메세지, 다르면 수정되었다고 flag 변경한다.
        this.updatedFlag = JSON.stringify(this.originalInfo) !== JSON.stringify(this.replyInfo)
      }
    }
  },
  // updated () {
  //   if (this.replyInfo.files.some(file => file.use === true)) { // 파일 첨부 여부에 따른 사이즈 변경
  //     if (this.editorHeight !== inputHeight.MINIMUM && this.$refs.attachedSpace.clientHeight >= 72) {
  //       this.resizeInfo.files = inputHeight.FILES_TWO
  //     } else {
  //       this.resizeInfo.files = inputHeight.FILES_ONE
  //     }
  //   } else {
  //     this.resizeInfo.files = ''
  //   }
  // },
  mounted () {
    eventBus.$on(`set-mail-template-${this.displayingChatRoomId}`, templateInfo => {
      if (this.loading) {
        return this.$alertMsg('転送中はテンプレートの使用が制限されます。')
      }
      if (this.active && this.isActiveStatus) {
        this.setMessage(templateInfo.templateAnswer)
      }
    })
  },
  destroyed () {
    eventBus.$off(`set-mail-template-${this.chatRoomId}`)
  },
  data () {
    return {
      type: 'MAIL',
      loading: false,
      fileLoading: false,
      // useRecipientCcFlag: false,
      // useRecipientBccFlag: false,
      updatedFlag: false,
      originalInfo: { // 답장할 고객 메세지 정보 백업.
        recipientTo: '',
        recipientCc: '',
        recipientBcc: '',
        subject: '',
        text: '',
        files: []
      },
      newInfo: { // 새로온 메시지 정보 저장.
        recipientTo: '',
        recipientCc: '',
        recipientBcc: '',
        subject: '',
        text: '',
        files: []
      },
      replyInfo: { // 답장할 메시지 정보 저장.
        recipientTo: '',
        recipientCc: '',
        recipientBcc: '',
        subject: '',
        text: '',
        files: [
          {id: 1, name: '', url: '', type: '', size: '', use: false}
        ]
      },
      editorDialog: false,
      editorHeight: inputHeight.DEFAULT,
      resizeInfo: {
        // 참조, 숨은참조
        // recipients: '',
        files: ''
      },
      styleAttachedFilesSpace: {
        height: 78
      },
      subjectMaxLength: {
        minScreen: 50,
        maxScreen: 100
      },
      fileNameMaxLength: {
        minScreen: 53,
        maxScreen: 149
      },
      coverHeight: 0,
      ticketDisplayIdGuid: `クリックしてタイトルに [🎟#チケットID]️を 追加する.<br>
        相談終了後に来た返信メールの件名に [🎟#チケットID]️ 形式があれば、1つのチケットで管理されます。`,
      maxFileLength: '10',
      editorConfig: {
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        defaultActionOnPaste: 'INSERT_AS_TEXT'
      }
    }
  },
  methods: {
    setMessage (templateAnswer) {
      this.replyInfo.text = templateAnswer + this.$refs.mailEditor.getHtml()
      this.$refs.mailEditor.setHtml(this.replyInfo.text)
    },
    updateLastMailMessage () { // 가장 최근에 온 메세지 정보로, 답장 정보를 세팅한다.
      // 새 메세지 담는다.

      this.newInfo.subject = this.makeSubject()
      this.newInfo.recipientTo = this.parseFromContent('fromAddress')
      this.newInfo.recipientCc = ''
      this.newInfo.recipientBcc = ''
      this.newInfo.text = this.generateNewText()

      this.setOriginalInfo() // 작성중인것을 새메세지 정보로 덮으면 안되니까, 작성중인 메세지와 새 메세지 구분한다.
    },
    parseFromContent (key) {
      const jsonContent = JSON.parse(this.lastMailMessage)
      return jsonContent[key]
    },
    validEmail (str) {
      let isEmailValid = true
      let emailList = str.split(',')

      emailList.forEach(email => {
        if (!helper.isEmailValid(email.trim())) {
          isEmailValid = false
        }
      })
      return isEmailValid
    },
    sendMessage () {
      this.replyInfo.text = ''
      this.replyInfo.text = this.$refs.mailEditor.getHtml()

      let files = JSON.parse(JSON.stringify(this.replyInfo.files))

      if (this.loading === false) {
        this.loading = true
        if (!helper.isStringValid(this.replyInfo.subject.trim())) {
          this.loading = false
          this.$alertMsg('タイトルを入力してください。')
          return
        }

        if (!helper.isStringValid(this.replyInfo.recipientTo.trim())) {
          this.loading = false
          this.$alertMsg('受信者のメールアドレスを入力してください。')
          return
        } else {
          if (!this.validEmail(this.replyInfo.recipientTo.trim())) {
            this.loading = false
            this.$alertMsg('受信者のメールアドレスの形式が正しくありません。')
            return
          }
        }

        // if (helper.isStringValid(this.replyInfo.recipientCc.trim())) {
        //   if (this.validEmail(this.replyInfo.recipientCc.trim()) === false) {
        //     this.loading = false
        //     this.$alertMsg('참조 메일 주소 형식이 잘못되었습니다.')
        //     return
        //   }
        // }
        //
        // if (helper.isStringValid(this.replyInfo.recipientBcc.trim())) {
        //   if (this.validEmail(this.replyInfo.recipientBcc.trim()) === false) {
        //     this.loading = false
        //     this.$alertMsg('비밀 참조 메일 주소 형식이 잘못되었습니다.')
        //     return
        //   }
        // }

        if (!helper.isStringValid(this.replyInfo.text.trim()) || this.checkTextBlank()) {
          this.loading = false
          this.$alertMsg('内容を入力してください。')
          return
        }

        if (this.replyInfo.text.length > 4294960000) {
          this.loading = false
          this.$alertMsg('内容が長すぎます。 減らしてください。')
          return
        }

        files = files.filter(file => file.use === true)
        files.forEach(file => {
          delete file['id']
          delete file['use']
        })
        this.editorDialog = false
      } else {
        return false
      }
      // this.resizeCoverHeight()
      this.axios.post('/api/chat/sendMailMessage', {
        agentId: this.agentId,
        chatRoomId: this.chatRoomId,
        recipientTo: this.replyInfo.recipientTo,
        recipientCc: this.replyInfo.recipientCc,
        recipientBcc: this.replyInfo.recipientBcc,
        subject: this.replyInfo.subject,
        text: this.replyInfo.text,
        files: JSON.stringify(files)
      }).then(res => {
        if (res.data.code !== 0) throw res.data.message
        this.setMessageScrollBottom() // 스크롤 맨 밑으로
        this.initMessage() // 메세지 데이터 초기화
      }, () => this.$alertMsg(this.$const.SYS_ERR))
        .catch(errorMsg => this.$alertMsg(errorMsg))
        .finally(() => {
          this.loading = false
        })
    },
    setOriginalInfo () {
      if (!this.updatedFlag) { // 상담사가 답장 정보 변경안했으면, 초기 메세지 정보(originalInfo)와 답장용 정보(replyInfo) 에 새 메세지 정보를 세팅한다.
        // 원본데이터 세팅
        this.originalInfo.recipientTo = this.newInfo.recipientTo
        this.originalInfo.recipientCc = this.newInfo.recipientCc
        this.originalInfo.subject = this.newInfo.subject
        this.originalInfo.text = this.newInfo.text
        this.originalInfo.files = []

        // 답장용 데이터 세팅
        this.replyInfo.recipientTo = this.newInfo.recipientTo
        this.replyInfo.recipientCc = this.newInfo.recipientCc
        this.replyInfo.subject = this.newInfo.subject
        this.replyInfo.text = this.newInfo.text
        this.replyInfo.files = []

        //  cc, bcc 있으면 사이즈 변경
        // this.useRecipientCcFlag = !!this.replyInfo.recipientCc
        // this.useRecipientBccFlag = !!this.replyInfo.recipientBcc

        // this.resizeInputHeight()
      }
    },
    updateContent (content) { // 에디터로 변경된 데이터를 반영
      this.replyInfo.text = content
    },
    // toggleRecipientCc () {
    //   this.useRecipientCcFlag = !this.useRecipientCcFlag
    //
    //   if (this.replyInfo.recipientCc) { // 입력값이 있으면 무조건 true
    //     this.useRecipientCcFlag = true
    //   }
    //
    //   this.resizeInputHeight()
    // },
    // toggleRecipientBcc () {
    //   this.useRecipientBccFlag = !this.useRecipientBccFlag
    //
    //   if (this.replyInfo.recipientBcc) { // 입력값이 있으면 무조건 true
    //     this.useRecipientBccFlag = true
    //   }
    //
    //   this.resizeInputHeight()
    // },
    toDefault () {
      this.editorHeight = inputHeight.DEFAULT
      this.resizeInputHeight()
    },
    toMinimize () {
      if (this.editorHeight === inputHeight.MINIMUM) { // 디폴트로
        this.editorHeight = inputHeight.DEFAULT
      } else { // 최소화로
        this.editorHeight = inputHeight.MINIMUM
      }

      // this.resizeInputHeight()
    },
    resizeInputHeight () { // 파일 업로드해서 입력창 사이즈 조절
      this.resizeMailHeight(this.editorHeight, this.resizeInfo)
    },
    resizeCoverHeight () {
      let defaultCoverHeight = 365
      if (this.editorHeight === inputHeight.MINIMUM) {
        defaultCoverHeight -= 275
      } else if (this.resizeInfo.files === inputHeight.FILES_TWO) {
        defaultCoverHeight += 88
      } else if (this.resizeInfo.files === inputHeight.FILES_ONE) {
        defaultCoverHeight += 52
      }
      this.coverHeight = defaultCoverHeight
    },
    // calculateSize () {
    //   if (this.useRecipientCcFlag && this.useRecipientBccFlag) { // 참조, 비밀참조에 따른 사이즈 변경
    //     this.resizeInfo.recipients = inputHeight.RECIPIENT_CC_TWO
    //   } else if (this.useRecipientCcFlag || this.useRecipientBccFlag) {
    //     this.resizeInfo.recipients = inputHeight.RECIPIENT_CC_ONE
    //   } else this.resizeInfo.recipients = ''
    //
    //   return this.resizeInfo
    // },
    toggleEditorDialog () {
      this.editorDialog = !this.editorDialog
    },
    initMessage () {
      this.replyInfo.text = ''
      this.replyInfo.files = []

      this.originalInfo.text = ''
      this.originalInfo.files = []

      this.updatedFlag = false
    },
    fileChanged (event) {
      let files = event.target.files

      if (!files) return
      if (this.fileLoading) return
      this.fileLoading = true
      const formData = new FormData()

      if (this.checkFileSize(files)) {
        this.fileLoading = false
        this.$alertMsg('ファイル容量が 10MBを超えています。')
        return false
      }
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        const validTypes = ['image/png', 'image/jpeg', 'image/bmp']
        if (!validTypes.includes(file.type)) {
          this.$alertMsg('許可されていないファイル拡張子です。')
          return
        }
        formData.append('file', file, file.name)
      }
      formData.append('brandId', this.brandId)
      this.axios.post('/api/external/mail/fileUpload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        if (res.data.code !== 0) throw res.data.message

        let attachedFiles = res.data.data

        for (let file of attachedFiles) {
          let obj = {}
          obj['id'] = this.replyInfo.files.length + 1
          obj['name'] = file.fileOriginalName
          obj['url'] = file.filePath
          obj['type'] = file.fileType
          obj['size'] = file.fileSize
          obj['use'] = true
          this.replyInfo.files.push(obj)
        }
      }, () => this.$alertMsg(this.$const.SYS_ERR))
        .catch(errorMsg => this.$alertMsg(errorMsg))
        .finally(() => {
          this.fileLoading = false
        })
    },
    generateNewText () {
      const newInfoText = this.parseFromContent('text')
      const receivedDivideText = '<br><br>-------------------Received Message------------------------<br>'
      let newText = newInfoText !== '' ? receivedDivideText + newInfoText : newInfoText
      newText = newText.replace('<body>', '')
      newText = newText.replace('</body>', '')
      return newText
    },
    checkTextBlank () {
      let text = this.replyInfo.text
      text = text.replace(/&nbsp;/g, '')
      text = text.replace(/<br>/g, '')
      text = text.replace(/<p>/g, '')
      text = text.replace(/<\/p>/g, '')

      return !helper.isStringValid(text.trim())
    },
    makeSubject () {
      // if (this.parseFromContent('subject').includes(`[🎟️${this.ticketDispId}]`) || !this.ticketDispId) {
      //   return `Re: ${this.parseFromContent('subject')}`
      // } else {
      //   return `Re: [🎟️${this.ticketDispId}] ${this.parseFromContent('subject')}`
      // }
      return `Re: ${this.parseFromContent('subject')}`
    },
    reduceSubject (subject, maxLength) {
      if (subject.length > maxLength) {
        return helper.reduceText(subject, maxLength)
      }
      return subject
    },
    reduceFileName (fileName, maxLength) {
      return helper.reduceFileName(fileName, maxLength)
    },
    resetFileInput () {
      this.$refs.fileInput.value = ''
      if (this.$refs.fileInput_dialog) {
        this.$refs.fileInput_dialog.value = ''
      }
    },
    checkFileSize (files) {
      const maxLength = this.maxFileLength * 1024 * 1024

      let allFileSize = 0
      let fileSizeSum = 0
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        let size = file.size

        allFileSize += size
        fileSizeSum = this.getAllFileSize() + allFileSize

        // 각각 파일 용량 체크 / 업로드된 파일 + 각각 파일 용량 체크
        if (size > maxLength || fileSizeSum > maxLength || allFileSize > maxLength) {
          return true
        }
      }

      return false
    },
    getAllFileSize () {
      let allFileSize = 0
      if (this.replyInfo.files) {
        this.replyInfo.files.forEach(file => {
          if (file.use) {
            allFileSize += file.size
          }
        })
      }
      return allFileSize
    },
    convertFileSize (size) {
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
      if (size <= 0) return '0B'
      let i = Math.floor(Math.log10(size) / Math.log10(1024))
      return parseFloat((size / Math.pow(1024, i)).toFixed(2)) + sizes[i]
    },
    removeFile (file) {
      const index = this.replyInfo.files.indexOf(file)
      this.replyInfo.files.splice(index, 1)
    }
  }
}
</script>
<style scoped>
  .msg-bg {
    background: white;
    max-width: 600px;
    box-shadow: 4px 0 14px 0 rgba(69, 65, 78, .2);
    border-radius: 3px;
  }

  .scroll {
    overflow-y: auto;
  }

  /*상담 레이아웃 상단 텝 영역 시작*/
  .top-tab {
    background: #666666;
    border-radius: 4px 4px 0px 0px;
    margin: -8px -8px;
    color: #ffffff;
    font-size: 14px;
    font-weight: bold;
  }

  .dialog-top-tab {
    background: #666666;
    margin: -6px;
  }

  .window-icon {
    float: right;
  }

  .window-size-icon {
    color: white;
  }

  /*!상담 레이아웃 상담 텝 영역 종료!*/

  /*이메일 상담 input 영역 시작*/
  .mailSubtitle {
    width: calc(100% - 65px);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .ticket-display-button {
    height: 28px;
    background-color: #fdf09e !important;
    font-size: 13px;
  }

  .receive-data_01 {
    margin-top: -5px;
  }

  /*!이메일 상담 input 영역 종료!*/

  /*상담 레이아웃 하단 버튼*/
  .attach-button {
    width: 80px !important;
    height: 30px !important;
    border-radius: 6px;
  }

  .attach-button:hover {
    background: #F4F4F4 !important;
  }

  .dialog-attach-button {
    width: 80px !important;
    height: 36px !important;
    border-radius: 6px;
  }

  .dialog-attach-button:hover {
    background: #F4F4F4 !important;
  }

  .progress-bar {
    width: 120px;
  }

  .dialog-progress-bar {
    width: 400px;
  }

  .send-button {
    width: 80px;
    height: 30px;
  }

  .dialog-send-button {
    width: 80px;
    height: 36px;
  }

  .cover-input {
    position: absolute;
    z-index: 2;
    width: 100%;
    background-color: darkgrey;
    opacity: 0.5;
    left: 0;
    right: 0;
    border-radius: 4px 4px 0px 0px;
    margin: -8px 0px 0px 0px;

  }

  /*!상담 레이아웃 하단 버튼!*/

  /* 에디터 다이얼로그 */

  .icon-container {
    position: absolute;
    right: 10px;
    top: calc(50% - 10px);
  }

  .loader {
    position: relative;
    height: 20px;
    width: 20px;
    display: inline-block;
    animation: around 5.4s infinite;
  }
</style>



// WEBPACK FOOTER //
// src/components/operation/fragments/chat_area/mail_input.vue